// src/HomePage.js

import React from 'react';
import { Typography, Container, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function HomePage() {
  // The redirect logic has been moved to App.js in the PublicRoute component.
  // This component is now purely presentational for unauthenticated users.

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome to the Best Document Retrieval System (BETA) - CPU SERVER
        </Typography>
        <Typography variant="h6" component="p" align="center" gutterBottom>
          Sign up or log in to upload your documents and start interacting with our AI assistant!
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/signup"
            sx={{ mr: 2 }}
          >
            Sign Up
          </Button>
          <Button
            variant="outlined"
            color="primary"
            component={Link}
            to="/price"
            sx={{ mr: 2 }}
          >
            View Pricing
          </Button>
          <Button
            variant="outlined"
            color="primary"
            component={Link}
            to="/login"
          >
            Login
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default HomePage;
